import { Box } from "@chakra-ui/react";
import { ArrowLink } from "src/components/base/arrow-link";
import { HorizontalScrollSnapCards } from "src/components/common/horizontal-scroll-snap-cards/horizontal-scroll-snap-cards";
import { ModulePrimaryHeadline } from "src/components/common/module-headlines";
import { IBestsellerData } from "src/components/modules/bestseller-module/bestseller.types";
import { SimpleRichText } from "src/components-mui/common/rich-text/simple-rich-text";
import { Container } from "src/components-mui/layout/container";
import { ILink } from "src/types/common";
import { Bestseller } from "./bestseller";

const THREE_BESTSELLER_MODULE_TEST_ID = "three-bestseller-module";

export interface IThreeBestsellerModuleProps {
    title: string;
    description: string;
    wikifolios: IBestsellerData[];
    more?: ILink;
}

export const ThreeBestsellerModule = ({ title, description, wikifolios, more }: IThreeBestsellerModuleProps) => (
    <Container data-test-id={THREE_BESTSELLER_MODULE_TEST_ID}>
        <ModulePrimaryHeadline mb={[3]}>{title}</ModulePrimaryHeadline>
        <SimpleRichText text={description} sx={{ mb: [4, 4, 4, 5] }} fontSize="lg" />
        <HorizontalScrollSnapCards cardsData={wikifolios} Card={Bestseller} />
        {more && (
            <Box textAlign={["left", "right"]} mt={5}>
                <ArrowLink href={more.url} target={more.target} colorScheme="green">
                    {more.name}
                </ArrowLink>
            </Box>
        )}
    </Container>
);
